/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SelfServiceDefaultValuesForOpenstack extends models.SelfServiceDefaultValuesBase {
    getFixupPrototypeFunction() { return SelfServiceDefaultValuesForOpenstack.fixupPrototype; }

    static newInstance(model: Partial<SelfServiceDefaultValuesForOpenstack>): SelfServiceDefaultValuesForOpenstack {
        let obj = Object.assign(new SelfServiceDefaultValuesForOpenstack(), model);
        SelfServiceDefaultValuesForOpenstack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SelfServiceDefaultValuesForOpenstack>): SelfServiceDefaultValuesForOpenstack {
        if (!model) return null;
        return SelfServiceDefaultValuesForOpenstack.newInstance(<SelfServiceDefaultValuesForOpenstack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SelfServiceDefaultValuesForOpenstack) {
        if (!obj) return;

        models.SelfServiceDefaultValuesForOpenstack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SelfServiceDefaultValuesForOpenstack): boolean {
        if (models.SelfServiceDefaultValuesBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SelfServiceDefaultValuesForOpenstack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Default Tenant
     */
    tenants: string;

    /**
     * Default Public Network
     */
    public_network: string;

    /**
     * Default Private Network
     */
    private_network: string;

}
